import Papa from "papaparse";

function downloadBlob(contents, mimeType, filename) {
  const url = URL.createObjectURL(new Blob([contents], { type: mimeType }));
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}

const safeFilePart = (value) => String(value || "path").trim().replace(/[^a-z0-9_-]+/gi, "-").replace(/^-|-$/g, "");

function normalizedRows(collectionId, runId, path, samples) {
  return samples.flatMap((sample) => {
    const common = {
      data_collection_id: collectionId,
      run_id: runId,
      path_id: path.id,
      path_name: path.name || "Untitled path",
      sample_index: sample.sample_index,
      sampled_at: sample.sampled_at,
      route_error_count: sample.route_error_count ?? 0,
    };
    const toRow = (recordType, value, indexes = {}) => ({
      ...common,
      record_type: recordType,
      ...indexes,
      live_distance_meters: value?.live_distance_meters ?? "",
      live_duration_seconds: value?.live_duration_seconds ?? "",
      live_baseline_duration_seconds: value?.live_baseline_duration_seconds ?? "",
      live_delay_seconds: value?.live_delay_seconds ?? "",
      live_traffic_delay_percent: value?.live_traffic_delay_percent ?? "",
      one_week_distance_meters: value?.one_week_distance_meters ?? "",
      one_week_duration_seconds: value?.one_week_duration_seconds ?? "",
      one_week_baseline_duration_seconds: value?.one_week_baseline_duration_seconds ?? "",
      one_week_delay_seconds: value?.one_week_delay_seconds ?? "",
      one_week_traffic_delay_percent: value?.one_week_traffic_delay_percent ?? "",
    });
    return [
      toRow("whole_path", sample.whole_path),
      ...(sample.segments || []).map((segment) => toRow("segment", segment, {
        from_point_index: segment.from_point_index,
        to_point_index: segment.to_point_index,
      })),
    ];
  });
}

export function downloadPathRunCsv(collectionId, runId, path, samples) {
  const filename = `${safeFilePart(collectionId)}__${safeFilePart(runId)}__${safeFilePart(path.name || path.id)}.csv`;
  downloadBlob(Papa.unparse(normalizedRows(collectionId, runId, path, samples)), "text/csv;charset=utf-8", filename);
}

export function downloadPathRunJson(collectionId, runId, path, samples) {
  const filename = `${safeFilePart(collectionId)}__${safeFilePart(runId)}__${safeFilePart(path.name || path.id)}.json`;
  const payload = { data_collection_id: collectionId, run_id: runId, path, samples };
  downloadBlob(JSON.stringify(payload, null, 2), "application/json;charset=utf-8", filename);
}

